import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterAttributeOptionComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-option.component.def';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { Model } from '@df/catalog/model';
import { IProductDataV2 } from '@df/catalog/product/product';
import { Status } from '@df/core/status';
import { NgInject } from '@df/ng/ng-inject';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ModalService } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IconLabelComponent } from 'projects/app-default/src/app/common/icon-label/icon-label.component';
import { BoxComponent } from 'projects/app-default/src/app/ui/display/box/box.component';
import { NProductSizeGuideModal } from '../../../../../cms/modal/product-size-guide/product-size-guide-modal.interface';
import { SwatchComponent } from '../../../../attribute/swatch/swatch.component';
import { LocalProduct } from '../../../../model/product/product.decorator';
@Component({
    selector: 'product-bundle-options-attribute',
    templateUrl: './product-bundle-options-attribute.component.html',
    standalone: true,
    imports: [TranslationModule, AttributeLabelPipe, OptionLabelPipe, IconLabelComponent, SwatchComponent, BoxComponent, CommonModule],
    styleUrls: ['./product-bundle-options-attribute.component.scss']
})
export class ProductBundleOptionsAttributeComponent<T extends Model> extends FilterAttributeOptionComponentDef<T> implements OnInit {
    @Input()
    product?: LocalProduct<IProductDataV2>;
    @Input()
    defaultOption: number;
    @Input()
    sizeGuideVariant: string;
    @Input()
    isFirst?: boolean;
    @Output()
    hoveredColor = new EventEmitter<number | undefined>();
    private status = new Status();
    color: string;
    currentColorValue: number;
    @NgInject(DfModalService)
    DfModalService: DfModalService;
    @NgInject(ModalService)
    modalService: ModalService;
    override ngOnInit(): void {
        super.ngOnInit();
        const currentOption = this.filter.options.find(option => option?.value === this.defaultOption);
        if (currentOption) {
            this.filter.reset();
            this.filter.select(currentOption);
        }
    }
    selectFilterAndUpdate(option: Catalog.IAttributeOption) {
        this.filter.select(option, true);
        this.detectChanges();
    }
    openSizeGuideModal() {
        // this.modalService.closeAll();
        this.DfModalService.open(this.status, NProductSizeGuideModal.BLOCK_ID, (this.product as LocalProduct).sizeGuideVariant);
    }
    updateColorOnMouseEnter(colorNumber: number) {
        this.currentColorValue = colorNumber;
        this.detectChanges();
        this.hoveredColor.emit(colorNumber);
    }
    updateColorOnMouseLeave() {
        this.currentColorValue = undefined;
        this.detectChanges();
        this.hoveredColor.emit(undefined);
    }
    /**
     * For color attribute all options are allowed
     * for other attributes only these with matches
     */
    get allowedOptions() {
        return this.filter.id === 'color' ? this.filter.optionsWithMatches : this.filter.optionsWithCurrentMatches;
    }
}
